{
  "tile": 32,
  "tileh": 32,
  "map": {
    "waterHorizon": [0, 17, 8, 5],
    "waterMiddle": [32, 0, 16, 6],
    "waterFront1": [0, 29, 16, 3],
    "waterFront2": [16, 29, 16, 3],
    "coastStart": [18, 12, 8, 1],
    "coast": [8, 17, 8, 1],

    "cityBridge": [0, 24, 16, 5],
    "cityStart": [0, 0, 16, 9],
    "city": [16, 0, 16, 9],
    "cityLayer2": [0, 9, 12, 8],
    "cityDistance": [32, 6, 8, 7],
    "cityDistanceBaseBottom": [32, 9, 8, 4],
    "cityDistanceBaseTop": [40, 6, 8, 7],

    "grassFront": [50, 13, 32, 3],
    "grassMiddle": [50, 7, 16, 6],
    "pond": [55, 0, 16, 6],
    "pondStart": [72, 0, 16, 6],
    "hedge": [67, 8, 12, 5],

    "roof": [67, 17, 14, 14],
    "chimney": [58, 33, 1, 4],
    "present": [57, 34, 1, 1],
    "villageSkyline": [49, 39, 16, 8],
    "villageSkylineFull": [49, 39, 16, 19],
    "villageDistantSkyline": [49, 33, 8, 4],
    "hillSkyline": [49, 38, 6, 1],

    "playerTop": [0, 63, 5, 4],
    "playerBottom1": [0, 67, 5, 2],
    "playerBottom2": [5, 67, 5, 2],

    "portraitJinte1": [16, 59, 4, 4],
    "portraitJinte2": [20, 59, 4, 4],
    "portraitJonas": [16, 64, 4, 7],
    "portraitSint": [22, 64, 5, 6],

    "fish": [10, 59, 2, 2],
    "bird": [12, 59, 2, 2],
    "seagull": [11, 63, 3, 3],
    "flats": [10, 61, 1, 1],
    "carrot": [8, 61, 1, 1],
    "moon": [12, 61, 2, 2],
    "title": [51, 59, 13, 15],

    "bigBuildingTop": [16, 13, 13, 6],
    "bigBuildingBrokenTop": [30, 13, 13, 6],

    "bigBuildingLayer": [16, 19, 13, 4],
    "bigBuildingBottom": [16, 23, 13, 6],
    "bigBuildingBottom2": [30, 23, 13, 6],

    "glass": [12, 9, 4, 3],
    "cloud": [16, 9, 8, 3],
    "shadow": [16, 12, 2, 1],
    "bridgeDeck": [0, 32, 16, 4],
    "damagedBridgeDeck": [16, 32, 16, 4],
    "bridgePillar": [36, 29, 6, 17],
    "bridgePillarBroken": [42, 29, 6, 17],
    "bigGlare": [0, 38, 7, 7],
    "sun": [12, 13, 3, 3],
    "chute": [12, 12, 1, 1],
    "directGlare": [8, 18, 6, 6],
    "aircraftCarrierEnd": [30, 43, 6, 5],
    "aircraftCarrierStart": [19, 43, 6, 5],
    "aircraftCarrierBottomFlat": [22, 45, 4, 3],
    "aircraftCarrierBottomSpace": [26, 45, 4, 3],
    "aircraftCarrierTopFlat": [26, 43, 4, 2],
    "aircraftCarrierClosed": [8, 44, 3, 3],
    "aircraftCarrierDoor": [11, 44, 1, 3],
    "aircraftCarrier5": [14, 42, 1, 1],
    "aircraftCarrier7": [14, 41, 1, 1],
    "aircraftCarrierEngine": [15, 41, 3, 3],
    "aircraftCarrierEngineDestroyed": [15, 38, 3, 3],
    "aircraftCarrierEngineMeter": [14, 43, 1, 1],

    "aircraftCarrierOpenHatch": [31, 38, 4, 1],
    "aircraftCarrierHatchLid": [31, 39, 4, 1],

    "aircraftCarrierLowCabin": [17, 46, 1, 2],
    "aircraftCarrierLowCabinStart": [18, 46, 1, 2],

    "aircraftCarrierCabinStart": [7, 38, 1, 6],
    "aircraftCarrierCabinRadar": [8, 38, 2, 6],
    "aircraftCarrierCabin": [10, 38, 2, 6],
    "aircraftCarrierCabinEnd": [12, 38, 2, 6],

    "aircraftCarrierCabinStartBroken": [18, 39, 1, 4],
    "aircraftCarrierCabinRadarBroken": [19, 39, 2, 4],
    "aircraftCarrierCabinBroken": [21, 39, 2, 4],
    "aircraftCarrierCabinEndBroken": [23, 39, 2, 4],

    "aircraftCarrierRadar": [26, 38, 2, 2],
    "aircraftCarrierRadarBroken": [26, 40, 2, 2],
    "aircraftCarrierRadarEmit": [23, 38, 2, 1],
    "aircraftCarrierAntenna": [29, 38, 2, 3],
    "aircraftCarrierWires": [25, 38, 1, 1],
    "aircraftCarrierHole": [22, 38, 1, 1],
    "boxes": [28, 39, 1, 1],
    "boxesFalling": [28, 38, 1, 1],
    "debris1": [44, 13, 4, 4],
    "stars": [44, 17, 21, 9],

    "playerShip": [0, 48, 3, 2],
    "playerShipTurning": [0, 46, 3, 2],
    "playerShipDamaged": [0, 50, 3, 2],
    "playerShipDamagedTurning": [3, 46, 3, 2],
    "playerShipFront": [6, 49, 3, 2],
    "muzzleFlash": [10, 48, 1, 1],
    "shipEngineFire": [4, 53, 3, 1],
    "freddie": [3, 49, 3, 2],
    "standardMine": [3, 51, 1, 1],
    "mineOpening1": [4, 51, 1, 1],
    "mineOpening2": [5, 51, 1, 1],
    "mineBlink": [6, 51, 1, 1],
    "standardDrone": [0, 52, 2, 2],
    "standardDroneDamage": [2, 52, 2, 2],
    "standardRocket": [4, 52, 2, 1],
    "bulletDrone": [0, 36, 2, 1],
    "helicopter": [0, 54, 4, 2],
    "helicopter2": [4, 54, 4, 2],
    "heliDamaged": [8, 54, 4, 2],
    "helicopterLanded": [12, 56, 4, 2],
    "helicopterTurning1": [16, 56, 2, 2],
    "helicopterTurning2": [18, 56, 2, 2],
    "helicopterGun": [12, 54, 1, 1],
    "standardLargeDrone": [0, 56, 3, 3],
    "standardLargeDroneDamage1": [3, 56, 3, 3],
    "standardLargeDroneDamage2": [6, 56, 3, 3],
    "standardLargeDroneDamage3": [9, 56, 3, 3],
    "rapidFireBoost": [11, 48, 1, 1],
    "speedBoost": [12, 48, 1, 1],
    "damageBoost": [13, 48, 1, 1],
    "aimBoost": [14, 48, 1, 1],
    "heart": [13, 49, 1, 1],
    "star": [14, 49, 1, 1],
    "upgrade": [15, 49, 1, 1],
    "powerUpBox": [10, 49, 1, 1],
    "powerUpBox2": [11, 49, 1, 1],
    "powerUpBox3": [12, 49, 1, 1],
    "sphere1": [7, 51, 1, 1],
    "sphere2": [8, 51, 1, 1],
    "lightBullet": [9, 51, 1, 1],
    "laserTank": [0, 59, 6, 3],
    "laserTankBarrel": [6, 59, 4, 2],
    "bulletCannon": [13, 55, 3, 1],
    "mineCannon": [11, 51, 2, 1],
    "turretFoot": [12, 55, 1, 1],

    "general1": [16, 48, 4, 4],
    "general2": [20, 48, 4, 4],
    "pilot1": [16, 52, 4, 4],
    "pilot2": [20, 52, 4, 4],

    "explosion1": [24, 48, 3, 3],
    "explosion2": [27, 48, 3, 3],
    "explosion3": [30, 48, 3, 3],
    "explosion4": [33, 48, 3, 3],
    "explosion5": [36, 48, 3, 3],

    "explosion6": [24, 51, 3, 3],
    "explosion7": [27, 51, 3, 3],
    "explosion8": [30, 51, 3, 3],
    "explosion9": [33, 51, 3, 3],
    "explosion10": [36, 51, 3, 3],

    "explosion11": [24, 54, 3, 3],
    "explosion12": [27, 54, 3, 3],
    "explosion13": [30, 54, 3, 3],
    "explosion14": [33, 54, 3, 3],
    "explosion15": [36, 54, 3, 3],

    "explosion16": [24, 57, 3, 3],
    "explosion17": [27, 57, 3, 3],
    "explosion18": [30, 57, 3, 3],
    "explosion19": [33, 57, 3, 3],
    "explosion20": [36, 57, 3, 3],

    "laserGunCore": [10, 50, 2, 1],
    "laserGunHandle": [11, 50, 2, 1],
    "laserGunBarrel": [13, 50, 3, 1],
    "bulletShell": [13, 12, 1, 1],
    "clothBottom": [12, 47, 5, 1],
    "cloth": [12, 44, 5, 3],

    "titleShip": [47, 26, 9, 5],
    "burstRing": [48, 0, 6, 6]
  }
}
